<div>
	<h3 class="title-h3">{{'bookingPayment.text.paymentWithMultibanco' | ibeadmin | async}}</h3>
	<p>
		{{'bookingPayment.text.paymentMustBeMadeIn' | ibeadmin | async}} <b> {{'bookingPayment.text.atm' | ibeadmin | async}} </b> {{'bookingPayment.text.boxOrThrough' | ibeadmin | async}} <b> {{'bookingPayment.text.homeBanking' | ibeadmin | async}} </b>, 
		{{'bookingPayment.text.selectingTheOption' | ibeadmin | async}} <b> {{'bookingPayment.text.paymentForPurchases' | ibeadmin | async}} </b>. <br>
		{{'bookingPayment.text.onceYouHaveCompleted' | ibeadmin | async}} <br>
		{{'bookingPayment.text.pleaseMakeSure' | ibeadmin | async}} <br>
		<!--
		O pagamento deverá ser efetuado numa caixa <b>Multibanco</b> ou através de <b>Homebanking</b>, selecionando a opção
		<b>Pagamento de Compras</b>.<br>
		Assim que concluir a sua reserva receberá um e-mail com os detalhes e instruções para realizar o pagamento.<br>
		Por favor, certifique-se de que indicou um e-mail correto quando preencheu os seus dados.<br>
		-->
	</p>
</div>

<div class="container no-pad-bottom no-pad-h" *ngIf="hasMilesPayable">
	<app-notification [style]="'information'" [icon]="'icons.svg#general--information'"
		[title]="'bookingPayment.title.milesRedemption' | ibeadmin | async">
		<div message>
			<span>
				{{'bookingPayment.text.pleaseNoteMilesRedeem' | ibeadmin | async}}
			</span>
		</div>
	</app-notification>
</div>

<div class="container no-pad-bottom no-pad-h">
	<app-notification [style]="'information'" [icon]="'icons.svg#general--timer'"
		[title]="('bookingPayment.text.reservationValidFor' | ibeadmin | async) + reservationValidityInHours + ' ' + ('bookingPayment.text.hours' | ibeadmin | async)">
		<div message>
			<span>
				{{'bookingPayment.text.makeThePayment' | ibeadmin | async}} {{ reservationValidityInHours }} {{'bookingPayment.text.reservationWillBeCancelled' | ibeadmin | async}}
			</span>
		</div>
	</app-notification>
</div>


<div class="container no-pad-bottom no-pad-h">
	<!-- <p>Apenas disponível para cartões de débito emitidos em Portugal.</p> -->
	<!-- <p><a class="link" href="javascript:;">Leia toda a informação sobre este método de pagamento</a></p> -->
	<p>{{'bookingPayment.text.onlyAvailableForDebitCards' | ibeadmin | async}}</p>
	<p>
		<a class="link link--external" href="https://www.flytap.com/en-pt/booking-information/payment-methods" target="_blank">
			{{'bookingPayment.text.readAllInformation' | ibeadmin | async}}
		</a>
	</p>
</div>

<div class="payment-option__conditions-wrapper" [class.has-error]="!(formIsValid$ | async)">
	<div class="payment-option__conditions">
		<app-checkbox-input (change)="INDRA_acceptTermsAndConditionsChange($event)" label="" [class.has-error]="!(formIsValid$ | async)"></app-checkbox-input> 
		<span>
			{{'bookingPayment.text.haveReadInFullAndAccept' | ibeadmin | async}} 
			<a class="link" href="javascript:;" 
				(click)="INDRA_handleBookingTicketConditions()" 
				[attr.aria-label]="'bookingPayment.aria.openFare' | ibeadmin | async" role="button">
				{{'bookingPayment.text.fareConditions' | ibeadmin | async}} 
			</a> 
			{{'bookingPayment.text.andThe' | ibeadmin | async}} 
			<a class="link link--external" href="javascript:;" 
				(click)="INDRA_gotoURL('externalURLs.transportConditions')"
				[attr.aria-label]="'bookingPayment.text.conditionsOfCarriage' | ibeadmin | async">
				{{'bookingPayment.text.conditionsOfCarriage1' | ibeadmin | async}} 
			</a> 
			<!--{{'bookingPayment.text.andThe' | ibeadmin | async}} 
			<a class="link link--external" href="javascript:;"
				(click)="INDRA_gotoURL('externalURLs.milesGoTermsConditions')">
				{{'bookingPayment.text.conditionsOfMilesGoProgramme' | ibeadmin | async}}
			</a>-->
			<ng-container *ngIf="displayCovidTermsAndCondition">
				, {{ 'bookingPayment.text.andAcceptCovidCondition' | ibeadmin | async }}
				<a class="link link--external" href="javascript:;"
					(click)="INDRA_gotoURL('externalURLs.canadaTravelMeasures')">
					{{ 'bookingPayment.text.termsConditions' | ibeadmin | async }}
				</a>
				{{ 'bookingPayment.text.covidCondition' | ibeadmin | async }}
			</ng-container>
		</span>
	</div>
</div>
